import { html } from "lit";
import { renderStandardPictureElement } from "../../../utils";

export function TemplateQuoteList() {
    return html`
        <div class="ux-iws-quote-list__teaser u-clearfix">
            <div
                class="gr-5 push-1 gr-10@t768 push-1@t768 gr-10@m push-1@m no-gutter"
            >
                ${renderStandardPictureElement({
                    width: 1440,
                    height: 788,
                })}
            </div>
            <div
                class="gr-1 push-1 gr-10@t768 push-1@t768 no-gutter@t768 gr-10@m push-1@m no-gutter@m"
            >
                <div
                    class="ux-iws-quote-list__teaser-separator"
                    style="background-image: url(https://www.trumpf.com/typo3conf/ext/trumpf_package/Resources/Public/Images/assets/quote-list-single-grfx_horizontal.png);"
                >
                    <img
                        src="/typo3conf/ext/trumpf_package/Resources/Public/Images/quote-list-single-grfx.png"
                        alt=""
                    />
                </div>
            </div>
            <div
                class="ux-iws-quote-list__text-content gr-4 push-1 gr-10@t768 push-1@t768 gr-10@m push-1@m no-gutter"
            >
                <h3 class="headline-small">"Quote content"</h3>
                <div class="ux-text-tiny ux-u-text-uppercase">
                    <strong>Some label content</strong>
                </div>
                <div class="ux-text-tiny u-color-gray-paragraph">
                    Subheadline
                </div>
            </div>
        </div>
    `;
}
